// Pages the review cards of <rv-reviews> when there are more than data-per-page. Fewer: nothing hidden, no arrows.
if (!customElements.get('rv-reviews')) {
  customElements.define('rv-reviews', class extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.per = Math.max(2, parseInt(this.dataset.perPage, 10) || 6);
      this.pages = Math.ceil(this.cards.length / this.per);
      this.page = 0;
      if (this.pages < 2) return;
      this.pager = this.querySelector('[data-pager]');
      this.pager.hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.page - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.page + 1));
      // Theme editor: selecting a block shows its page.
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.cards.indexOf(e.target);
        if (i > -1) this.show(Math.floor(i / this.per));
      });
      this.show(0);
    }

    show(page) {
      this.page = (page + this.pages) % this.pages;
      this.cards.forEach((c, i) => (c.hidden = Math.floor(i / this.per) !== this.page));
      this.querySelector('[data-count]').textContent = this.dataset.pageLabel.replace('__C__', this.page + 1).replace('__N__', this.pages);
    }
  });
}
